import config from './config';
import { isServer, getAppUrl } from './base';
import { log, error } from './debug';
import browser from './browser';
import assign from 'lodash/assign';
import User from './user';
import { loadJs } from './utils';

// 正式服的key
let key = '834fb8991e9eed2aab113b73a4924797';

const link = (options, params = {}, isRedirect = true) => {
  init(() => {
    var data: any = {};

    // data.type = "test";  //表示现在使用线上模式,如果填写"test", 表示测试模式.【可选】
    data.feature = '功能名称'; // 自定义深度链接功能，多个用逗号分隔，【可选】
    data.stage = '阶段名称'; // 自定义深度链接阶段，多个用逗号分隔，【可选】
    data.channel = '渠道名称'; // 自定义深度链接渠道，多个用逗号分隔，【可选】
    data.tags = '标签名称'; // 自定义深度链接标签，多个用逗号分隔，【可选】
    data.ios_custom_url = ''; // 首次集成测试请留空！！！自定义iOS平台下App的下载地址，如果是AppStore的下载地址可以不用填写，需填写http或https【可选】
    data.ios_direct_open = 'false'; //首次集成测试请默认为false！！！true：未安装情况下直接打开ios_custom_url，默认为false【可选】
    data.android_custom_url = ''; // 首次集成测试请留空！！！自定义安卓平台下App的下载地址，需填写http或https【可选】
    data.android_direct_open = ''; // 首次集成测试请默认为false！！！true:所有情况下跳转android_custom_url，不会走深度链接跳转打开APP的逻辑，默认为false【可选】
    // 下面是自定义深度链接参数，用户点击深度链接打开app之后，params的参数会通过LinkedME服务器透传给app，由app根据参数进行相关跳转
    // 例如：详情页面的参数，写入到params中，这样在唤起app并获取参数后app根据参数跳转到详情页面

    let qdInfo = User.getQdInfo();
    let qd = qdInfo.androidQd;
    if (browser.ios) {
      qd = qdInfo.iosQd;
    }

    let qdParams = {
      qd,
    };
    if (qdInfo.dynamicQd) {
      data.channel = qdInfo.dynamicQd;
    }

    data.params = JSON.stringify(assign(qdParams, params));

    log('deepLink', options.feature, data.params);

    assign(data, options);

    linkedme.link(
      data,
      function (err, response) {
        if (err) {
          location.href = getAppUrl();
          error('linked me fail');
        } else {
          log('linked me success', response.url);
          /*
                    生成深度链接成功，深度链接可以通过data.url得到，
                    将深度链接绑定到<a>标签，这样当用户点击这
                    个深度链接，如果是在pc上，那么跳转到深度链接二维
                    码页面，用户用手机扫描该二维码就会打开app；如果
                    在移动端，深度链接直接会根据手机设备类型打开ios
                    或者安卓app
                    */
          location.href = response.url;
          // cb && cb(response.url);
        }
      },
      false,
    );
  });
};

const linkHome = (params = {}) => {
  link(
    {
      feature: '跳转首页',
    },
    {
      ...params,
      page: 'home',
    },
  );
};

const linkRoom = (roomId) => {
  link(
    {
      feature: '跳转直播间',
    },
    {
      page: 'live',
      room_id: roomId,
    },
  );
};

const linkPay = () => {
  link(
    {
      feature: '打开充值页面',
    },
    {
      page: 'pay',
    },
  );
};
const linkCategory = (id, name) => {
  link(
    {
      feature: '打开品类页面',
    },
    {
      page: 'category',
      category: name,
      category_id: id,
    },
  );
};

let isInit = false;

const init = (cb) => {
  if (isServer()) {
    return;
  }
  if (!isInit) {
    loadJs('https://static.lkme.cc/linkedme.min.js', () => {
      // if (config.test || config.development) {
      //     key = 'd81a4ac899ea6079adb2d5428371a321'
      // }
      isInit = true;
      linkedme.init(key, { type: 'live' }, (err, response) => {
        if (err) {
          error('[linkedme init]', err);
        } else {
          log('[linkedme init] success');
          cb && cb();
        }
      });
    });
  } else {
    cb && cb();
  }
};

export default {
  linkHome,
  linkRoom,
  linkPay,
  linkCategory,
};
